import React from "react";
import Testata from "../../components/Testata/Testata";
import imgTestata from "../../assets/testate/testata-azienda.jpg";
import { AiOutlineFilePdf } from "react-icons/ai";
import imgIntro from "../../assets/certificazioni/intro.jpg";
import GalleryV from "../../components/Gallery/GalleryV";
import GalleryTestata from "../../components/Gallery/GalleryTestata";
import GallerySingola from "../../components/Gallery/GallerySingola";

const Quality = () => {
  return (
    <div>
      <GalleryTestata
        arrayFoto={["L1180164", "L1180253"]}
        titoloGallery="Azienda"
      />

      <div className="pt">
        <div className="container">
          <div className="intro text-center">
            <h2 className="mb0">Obiettivi di qualità</h2>
          </div>
        </div>
      </div>

      <div className="fluid-list">
        <div className="fluid-row">
          <div className="fluid-img">
            <GallerySingola
              arrayFoto={["L1180211"]}
              titoloGallery="Sicurezza / Qualità"
            />
          </div>
          <div className="fluid-txt">
            <div className="fluid-content">
              <p>
                La politica adottata da Italimpianti per la gestione della
                qualità, viene sintetizzata nei seguenti punti:
                <br />
                • Qualità dei lavori
                <br />
                • Soddisfazione del Cliente, nel rispetto del contratto
                stipulato
                <br />
                • Rispetto dei costi preventivati (efficienza)
                <br />
                • Aspetti ambientali
                <br />• Sicurezza sul lavoro
              </p>
              <p>
                Per ottenere i risultati prefissati nell’ambito qualitativo e
                nella persecuzione dei punti sopradescritti, è quindi stato
                fondamentale coinvolgere, attraverso attività formativa interna
                ed esterna, il personale interno alla nostra azienda, in modo da
                ottenere condivisione e partecipazione; la direzione infatti è
                sempre consapevole che solo con la condivisione e la piena ed
                efficiente collaborazione del personale si possono raggiungere
                tali ambiziosi obiettivi.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="pt pb bg1">
        <div className="container">
          <div className="intro mb2">
            <h2>Certificazioni / Attestazioni</h2>
            <p>
              Dal 2014 ad oggi, Italimpianti si evidenzia per l’impegno e la
              costanza nel conseguimento di Certificazioni e Attestazioni;
              alcuni obiettivi raggiunti che confermano scelte oculate:
            </p>
          </div>
          <div className="cert_list">
            <div>
              <a
                href="/download/04-IT-ITA-200057_CERTIFICATO.pdf"
                target="_blank"
              >
                <div className="cert-top">
                  SOA per l’esecuzione di opere pubbliche per le categorie:
                </div>
                <div className="icon">
                  <AiOutlineFilePdf />
                </div>
                <div className="cert-txt">
                  OS30 - “impianti interni elettrici, telefonici,
                  radiotelefonici, e televisivi” - class. II
                </div>
              </a>
            </div>
            <div>
              <a
                href="/download/04-IT-ITA-200058_CERTIFICATO_rev2.pdf"
                target="_blank"
              >
                <div className="cert-top">
                  Sistema di gestione Qualità in base alla Norma:
                </div>
                <div className="icon">
                  <AiOutlineFilePdf />
                </div>
                <div className="cert-txt">
                  ISO 9001:2015 – Costruzione e ristrutturazione di edifici.
                  Progettazione, installazione e manutenzione di impianti e
                  quadri elettrici
                </div>
              </a>
            </div>
            <div>
              <a
                href="/download/04-IT-ITA-200059_CERTIFICATO.pdf"
                target="_blank"
              >
                <div className="cert-top">
                  Sistema di Gestione Ambientale in base alla Norma:
                </div>
                <div className="icon">
                  <AiOutlineFilePdf />
                </div>
                <div className="cert-txt">
                  ISO 14001:2015 - Costruzione e ristrutturazione di edifici.
                  Progettazione, installazione e manutenzione di impianti e
                  quadri elettrici
                </div>
              </a>
            </div>
            <div>
              <a
                href="/download/04-IT-ITA-200059_CERTIFICATO.pdf"
                target="_blank"
              >
                <div className="cert-top">
                  Sistema di gestione per la Salute e Sicurezza del Lavoro in
                  base alla norma:
                </div>
                <div className="icon">
                  <AiOutlineFilePdf />
                </div>
                <div className="cert-txt">
                  ISO 45001:2018 - Costruzione e ristrutturazione di edifici.
                  Progettazione, installazione e manutenzione di impianti e
                  quadri elettrici
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="pt">
        <div className="container">
          <div className="intro text-center">
            <h2 className="mb0">Sicurezza sul lavoro</h2>
          </div>
        </div>
      </div>

      <div className="fluid-list">
        <div className="fluid-row">
          <div className="fluid-img">
            <GallerySingola
              arrayFoto={["L1180344"]}
              titoloGallery="Sicurezza / Qualità"
            />
          </div>
          <div className="fluid-txt">
            <div
              className="fluid-content"
              style={{ paddingTop: 0, paddingBottom: 0 }}
            >
              <p style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}>
                Italimpianti ha a cuore ed una particolare attenzione per la
                sicurezza sul Lavoro; da qui la decisione di inserire nel
                proprio organico un “UFFICIO SICUREZZA” interno, sempre
                impegnato nel:
                <br />
                Monitoraggio, aggiornamento ed adeguamento documentazione
                sicurezza interna (Aziendale, proprie maestranze e doc.
                sicurezza) ai fini dell’idoneità tecnico-professionale (art. 26,
                comma 1, d.lgs. n. 81/2008)
                <br />
                Verifica dell'idoneità tecnico-professionale delle imprese
                appaltatrici e dei lavoratori autonomi cui il datore di lavoro
                affida lavori, servizi e forniture (art. 26, comma 1, d.lgs. n.
                81/2008)
                <br />
                Gestione ed organizzazione corsi sicurezza lavoro (d.lgs
                81/2008), formazione ed aggiornamento / utilizzo appositi
                database dedicati e gestione scadenziari
                <br />
                Gestione e monitoraggio nomine e requisiti figure quali medico,
                RLS, RSPP, squadre antincendio, primo soccorso, coordinatori
                contatti esterni, personale PES e PAV
                <br />
                Partecipazione attiva a riunioni ed incontri quali: <br />
                o Riunioni periodiche di prevenzione e protezione dai rischi
                (art. 35, d. lgs 81/2008) <br />o Sopralluoghi, ai fini delle
                considerazioni e redazioni piani di sorveglianza sanitaria
                aziendale (art. 25, comma1, lettera a, d.lgs 81/2008)
                <br />
                4.1 Covid 19 - Sicurezza dei lavoratori
                <br />
                Vengono seguite con particolare attenzione tutte le
                raccomandazioni per imprese e lavoratori contenute nel
                protocollo tra Governo, sindacati e imprese firmato il 14 marzo
                e integrato il 24 aprile 2020.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Quality;
